import React, { useEffect, useContext } from 'react';
import UserContext from 'store/UserContext';
import * as requests from 'store/actions/requests';

type VideoType = {
  name: string;
  url: string;
  type: string;
  id: string;
};

type VideoJSProps = {
  video: VideoType
};

export const VideoJS = ({ video }: VideoJSProps) => {
  const containerStyle = {
    position: 'relative',
    width: '100%',
    height: 0,
    paddingBottom: '56.25%' // 16:9 aspect ratio
  };

  const videoStyle = {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%'
  };

  if (video.type === 0) {
    return (
      <div style={containerStyle}>
        <div style={videoStyle}>
          <iframe
            // src={"/api/vimeo-proxy/" + video.name}
            src={video.url}
            title={video.name}
            style={videoStyle}
            frameBorder="0"
            allowFullScreen
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          />
        </div>
      </div>
    );
  }

  return (
    <div style={containerStyle}>
      <iframe
        src={video.url}
        title={video.name}
        style={videoStyle}
        frameBorder="0"
        allowFullScreen
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      />
    </div>
  );
}

export default VideoJS;
